/** Shared by the nav bar and the page container so the two stay aligned. */
export const CONTENT_MAX_WIDTH = 1120;
